import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Subscription } from 'rxjs';
import { BlacksmithingJournalService } from './blacksmithing-journal.service';
import { ForgePhoto } from './blacksmithing-journal.model';

@Component({
    selector: 'app-blacksmithing-gallery',
    templateUrl: './blacksmithing-gallery.component.html',
    styleUrls: ['./blacksmithing-gallery.component.scss'],
    standalone: false
})
export class BlacksmithingGalleryComponent implements OnInit, OnDestroy {
  photos: ForgePhoto[] = [];
  userId: string | null = null;
  loading = true;

  lightboxPhoto: ForgePhoto | null = null;
  lightboxIndex = 0;

  private authSub?: Subscription;
  private photosSub?: Subscription;

  constructor(
    private auth: AngularFireAuth,
    private journalService: BlacksmithingJournalService
  ) {}

  ngOnInit() {
    this.authSub = this.auth.user.subscribe(user => {
      this.userId = user?.uid ?? null;
      if (this.userId) {
        this.loadPhotos();
      } else {
        this.loading = false;
      }
    });
  }

  ngOnDestroy() {
    this.authSub?.unsubscribe();
    this.photosSub?.unsubscribe();
  }

  private loadPhotos() {
    if (!this.userId) return;
    this.photosSub = this.journalService.getAllPhotos(this.userId).subscribe(photos => {
      this.photos = photos;
      this.loading = false;
    });
  }

  formatDate(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  openLightbox(photo: ForgePhoto) {
    this.lightboxPhoto = photo;
    this.lightboxIndex = this.photos.findIndex(p => p.id === photo.id);
  }

  closeLightbox() {
    this.lightboxPhoto = null;
  }

  prevPhoto() {
    if (this.lightboxIndex > 0) {
      this.lightboxIndex--;
      this.lightboxPhoto = this.photos[this.lightboxIndex];
    }
  }

  nextPhoto() {
    if (this.lightboxIndex < this.photos.length - 1) {
      this.lightboxIndex++;
      this.lightboxPhoto = this.photos[this.lightboxIndex];
    }
  }

  async deletePhoto(photo: ForgePhoto) {
    if (!this.userId || !confirm('Delete this photo?')) return;
    if (this.lightboxPhoto?.id === photo.id) this.closeLightbox();
    await this.journalService.deletePhoto(this.userId, photo);
  }
}
